import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { ISocialBannerIcon } from './social-banner.interface';

@Component({
    selector: 'mlp-ng-social-banner',
    templateUrl: './social-banner.component.html',
    styleUrls: ['./social-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SocialBannerSharedComponent {
    @Input() icons: Array<ISocialBannerIcon>;
    @Input() action = '//mylocalpitch.us7.list-manage.com/subscribe/post?u=a8becbd3c11bcdb30e3ca06cb&amp;id=c2e0463071';
    @Output() clickEvent: EventEmitter<ISocialBannerIcon> = new EventEmitter<ISocialBannerIcon>();

    sendClickEvent(item: ISocialBannerIcon): void {
        this.clickEvent.emit(item);
    }
}
